import React from 'react';

import { getDesignToken } from 'styles/constants';

import { DrinksTabLink, DrinksTabLinkText, DrinksTabsWrapper } from './styled';
import { DrinkCategoriesKeys, DrinksCategories } from './types';
import { convertKebabCaseToTitleCase } from './utils';

interface DrinksTabsProp {
  activeTab: DrinkCategoriesKeys;
  categories: DrinksCategories[];
  onTabChange: (tab: DrinkCategoriesKeys) => void;
}

export const ProductCustomizationDrinksTab: React.FC<DrinksTabsProp> = ({
  activeTab,
  categories,
  onTabChange,
}) => {
  if (!categories.length) {
    return null;
  }

  return (
    <DrinksTabsWrapper testID="product-customization-drinks-tabs">
      {categories.map(category => (
        <DrinksTabLink
          accessibilityRole="link"
          href="#"
          key={category}
          onPress={e => {
            e?.preventDefault();
            onTabChange(category);
          }}
          minWidth={`${100 / categories.length}%`}
          style={{
            borderBottomWidth: activeTab === category ? 2 : 0,
            borderBottomColor:
              activeTab === category ? getDesignToken('color-tertiary') : 'transparent',
          }}
        >
          <DrinksTabLinkText variant="headerTwo" active={activeTab === category}>
            {convertKebabCaseToTitleCase(category)}
          </DrinksTabLinkText>
        </DrinksTabLink>
      ))}
    </DrinksTabsWrapper>
  );
};
